module.exports = __webpack_public_path__ + "static/media/insta.fc23b902.svg";